import { render, staticRenderFns } from "./ResourceCascader.vue?vue&type=template&id=5d577210"
import script from "./ResourceCascader.vue?vue&type=script&lang=js"
export * from "./ResourceCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports